/**
 * The two places the map has to be told a colour in a language CSS variables
 * cannot reach.
 *
 * `PolylineOptions.color` and `MapOptions.defaultBackgroundColor` are hex
 * strings passed into WebGL — `var(--accent)` there is not a colour, it is a
 * parse error. So the token is READ from the document instead of being copied
 * into a second palette here: `tokens.css` stays the only place the values
 * live, and a theme switch changes the map's line by changing the variable.
 */

/** A design token's current value, or `fallback` outside a browser. */
export function cssToken(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

/**
 * Which 2GIS style the board should wear.
 *
 * v1 answers «the default one» in both themes, and that is a DECISION rather
 * than an omission (design §1.5): 2GIS publishes no dark style id, and a custom
 * style is an artefact in somebody's Style Editor account that no repository
 * versions. What we do own — the card frame, the overlays, the markers and the
 * route line — follows the theme. If a dark style is ever authored, this
 * function and `map.setStyleById()` are the whole of the wiring.
 */
export function styleIdForTheme(): string | undefined {
  return undefined;
}
